import { ReactComponent as IconDashboard } from "assets/svg/menu-dashboard.svg"
import { ReactComponent as IconUsers } from "assets/svg/menu-icon-users.svg"

import { MenuItem } from ".."

export const ReferralAgentMenu = () => {
  return (
    <>
      <MenuItem to="/dashboard" icon={<IconDashboard />} label="Dashboard" />

      <MenuItem to="/referrals" icon={<IconUsers />} label="My Referrals" />
    </>
  )
}
